<template>
  <div class="container">
    <CommonFrame :workNo="workNo"
                  :btns="btns"
                  :node="node"
                  :moduleName="moduleName"
                  :breadcrumb="breadcrumb"
                  :endStatus="approvalParams.endStatus"
                  :approvalTabStatus="approvalParams.approvalTabStatus"
    >
      <div slot="info">
        <h4>
          <span>损溢单号:</span>
          <span>{{id}}</span>
        </h4>
        <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="tableInfo">
        <div class="cardContainer">
          <lk-card title="盘点损溢信息">
            <lk-table border :columns='columns' :data='tableData'></lk-table>
          </lk-card>
        </div>
      </div>
    </CommonFrame>
  </div>
</template>

<script>
import axios from 'axios';
import utils from '@/libs/utils';
import CommonFrame from '../commonFrame.vue';

export default {
  name: 'StocktakingAdjust',
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
  },
  data() {
    return {
      workNo: '',
      node: '',
      moduleName: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批列表',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      infosArr: [],
      columns: [],
      tableData: [],
      id: '',
      statusMap: {
        1: '启用',
        2: '禁用',
      },
      dosageFormMap: {
        1: '片剂',
      },
      drugMiniPackageUnitMap: {
        1: '盒',
      },
      approveStatusMap: {
        1: '审批中',
        2: '审批通过',
        3: '审批驳回',
      },
    };
  },
  methods: {
    getStocktakingAdjustInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        const tempColumns = res.data.data.columns;
        tempColumns.forEach((item) => {
          this.columns.push({ title: item.title, key: item.key, minWidth: 116 });
        });
        // this.columns = res.data.data.columns;
        res.data.data.tableData.forEach((item) => {
          const result = {};
          utils.exchangeTable(item, result);
          result.createTime = utils.exchangeTime(item.createTime);
          result.goodsStoreStatusStr = this.statusMap[result.goodsStoreStatus];
          // result.dosageFormStr = this.dosageFormMap[result.dosageForm];
          result.dosageFormStr = result.dosageForm;
          // result.drugMiniPackageUnitStr = this.drugMiniPackageUnitMap[result.drugMiniPackageUnit];
          result.drugMiniPackageUnitStr = result.drugMiniPackageUnit;
          // result.approveStatusStr = this.approveStatusMap[result.approveStatus];
          if (result.changeInventory) {
            result.changeInventory = result.changeInventory === 1 ? '是' : '否';
          }
          if (result.adjustCount > 0) {
            result.adjustCount = `+${result.adjustCount}`;
          }
          this.tableData.push(result);
        });

        // this.tableData = res.data.data.tableData;
        this.id = res.data.data.id.toString();
        this.infosArr = res.data.data.infos;
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    const stocktakingAdjustArr = {
      name: 'approvalEdit',
      title: '盘点损溢单(有库存调整)',
    };
    const stocktakingNoAdjustArr = {
      name: 'approvalEdit',
      title: '盘点损溢单(无库存调整)',
    };
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.moduleName = this.approvalParams.moduleName;
    this.getStocktakingAdjustInfo(this.approvalParams.businessUrl);
    if (this.moduleName === 'stocktaking_adjust') {
      this.breadcrumb.push(stocktakingAdjustArr);
    } else {
      this.breadcrumb.push(stocktakingNoAdjustArr);
    }
  },
};
</script>

<style scoped>

</style>
